<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-qzone`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.653 44.428a2 2 0 01-2.673-1.942l.358-12.047-7.37-9.536a2 2 0 011.02-3.142l11.568-3.383 6.792-9.956a2 2 0 013.304 0l6.792 9.956 11.567 3.383a2 2 0 011.021 3.142l-7.37 9.536.358 12.047a2 2 0 01-2.673 1.942L24 40.365l-11.347 4.063zM24 36.117l9.935 3.557-.313-10.548 6.453-8.349-10.128-2.962L24 9.098l-5.947 8.717-10.128 2.962 6.453 8.35-.313 10.547L24 36.117zm6.819-14.298a1.9 1.9 0 01-.503 2.093l-6.32 5.688h5.049a1.9 1.9 0 110 3.8h-10a1.9 1.9 0 01-1.271-3.312l6.32-5.688h-5.049a1.9 1.9 0 110-3.8h10a1.9 1.9 0 011.774 1.22z"/></svg>
</template>
<script>

export default {
  name: 'IconQzone',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
